import { Component, Input, Output, EventEmitter } from '@angular/core';
import {
  CrossReference,
  CrossReferencesOpinionOption,
} from '../../../../types/types';

@Component({
    selector: 'app-vizient-assessment',
    templateUrl: './vizient-assessment.component.html',
    styleUrls: ['./vizient-assessment.component.scss'],
    standalone: false
})
export class VizientAssessmentComponent {
  @Input() opinion = '';
  @Input({ required: true }) crossReference!: CrossReference;
  @Input() crossReferenceOpinionOptions?: CrossReferencesOpinionOption[];
  @Input() isGPO = false;
  @Input() hasPermissionToAddOpinions = false;
  @Output() addNote = new EventEmitter();
  @Output() updateOpinion = new EventEmitter();

  constructor() {}

  onAddNote(noteMessage: string) {
    this.addNote.emit(noteMessage);
  }

  onUpdateOpinion({ opinionOptionKey }: { opinionOptionKey: string }) {
    const votedOpinionOption = this.crossReferenceOpinionOptions?.find(
      (option) => option.optionKey === opinionOptionKey,
    ) as CrossReferencesOpinionOption;

    const feedbackDescription = votedOpinionOption!.feedbackDescription;

    this.updateOpinion.emit({
      opinionOptionKey,
      opinionUpdates: {
        opinion: votedOpinionOption.opinion,
        feedbackDescription,
      },
    });
  }
}
